import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSubscription } from "./SubscriptionContext";
import Loader from "../Components/Loader";

const SubscriptionRoute = () => {
    const { hasAccess } = useSubscription();

    if (hasAccess === null) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                background: '#000029',
            }}>
                <Loader message="Checking subscription..." />
            </div>
        );
    }

    if (!hasAccess) {
        return <Navigate to="/settings/subscription" replace />;
    }

    return <Outlet />;
};

export default SubscriptionRoute;
